import { render, staticRenderFns } from "./ChannelPartnerRegister.vue?vue&type=template&id=10e2d138&scoped=true"
import script from "./ChannelPartnerRegister.vue?vue&type=script&lang=js"
export * from "./ChannelPartnerRegister.vue?vue&type=script&lang=js"
import style0 from "./ChannelPartnerRegister.vue?vue&type=style&index=0&id=10e2d138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2d138",
  null
  
)

export default component.exports